import { AmendOrderAlert } from './AmendOrderAlert';

export default AmendOrderAlert;
